import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Header, Icon, Segment, Card, Image } from 'semantic-ui-react';

const ContactUs = () => {
  const { t, i18n } = useTranslation();
  const isChinese = i18n.language === 'zh';
  const [zoomedImage, setZoomedImage] = React.useState(null);

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa', padding: '32px 0' }}>
      <Container style={{ maxWidth: '800px' }}>
        {/* 页面标题 */}
        <Segment style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '12px',
          padding: '40px',
          color: '#fff',
          textAlign: 'center',
          marginBottom: '32px',
        }}>
          <Header as='h1' style={{ color: '#fff', marginBottom: '16px' }}>
            <Icon name='mail' />
            {isChinese ? '联系我们' : 'Contact Us'}
          </Header>
          <p style={{ fontSize: '16px', margin: 0, opacity: 0.95 }}>
            {isChinese 
              ? '如需充值或有任何问题，请通过以下方式联系我们的客服团队'
              : 'For recharge or any questions, please contact our customer service team through the following methods'
            }
          </p>
        </Segment>

        {/* 联系方式卡片 */}
        <Card fluid style={{ borderRadius: '12px', boxShadow: '0 4px 16px rgba(0,0,0,0.1)' }}>
          <Card.Content>
            <Card.Header style={{ fontSize: '24px', marginBottom: '24px', textAlign: 'center' }}>
              <Icon name={isChinese ? 'weixin' : 'telegram'} color={isChinese ? 'green' : 'blue'} />
              {isChinese ? '客服联系方式' : 'Customer Service Contact'}
            </Card.Header>

            {isChinese ? (
              <div>
                {/* 微信二维码 */}
                <Segment style={{ background: '#f9f9f9', borderRadius: '8px', marginBottom: '24px' }}>
                  <Header as='h3' style={{ textAlign: 'center', color: '#07C160' }}>
                    <Icon name='weixin' />
                    微信客服
                  </Header>
                  <div style={{ textAlign: 'center', padding: '20px' }}>
                    <Image 
                      src='/wx.png' 
                      alt='微信客服二维码'
                      size='medium'
                      style={{ 
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        maxWidth: '300px',
                        cursor: 'zoom-in',
                      }}
                      onClick={() => setZoomedImage('/wx.png')}
                      onError={(e) => {
                        e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjMwMCIgZmlsbD0iI2YwZjBmMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTgiIGZpbGw9IiM5OTkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj7nlKjmiYvml6DmlofkuK3lm77niYc8L3RleHQ+PC9zdmc+';
                      }}
                    />
                    <p style={{ marginTop: '16px', color: '#666', fontSize: '14px' }}>
                      请使用微信扫描下方二维码添加客服
                    </p>
                  </div>
                </Segment>

                {/* 企业微信二维码 */}
                <Segment style={{ background: '#f9f9f9', borderRadius: '8px' }}>
                  <Header as='h3' style={{ textAlign: 'center', color: '#1890ff' }}>
                    <Icon name='building' />
                    企业微信客服
                  </Header>
                  <div style={{ textAlign: 'center', padding: '20px' }}>
                    <Image 
                      src='/qw.png' 
                      alt='企业微信客服二维码'
                      size='medium'
                      style={{ 
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        maxWidth: '300px',
                        cursor: 'zoom-in',
                      }}
                      onClick={() => setZoomedImage('/qw.png')}
                      onError={(e) => {
                        e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjMwMCIgZmlsbD0iI2YwZjBmMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTgiIGZpbGw9IiM5OTkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj7kvJrnlKjml6DmloflsI7luIY8L3RleHQ+PC9zdmc+';
                      }}
                    />
                    <p style={{ marginTop: '16px', color: '#666', fontSize: '14px' }}>
                      请使用企业微信扫描下方二维码
                    </p>
                  </div>
                </Segment>
              </div>
            ) : (
              <div>
                {/* Telegram */}
                <Segment style={{ background: '#f9f9f9', borderRadius: '8px' }}>
                  <Header as='h3' style={{ textAlign: 'center', color: '#0088cc' }}>
                    <Icon name='telegram' />
                    Telegram Customer Service
                  </Header>
                  <div style={{ textAlign: 'center', padding: '20px' }}>
                    <Image 
                      src='/fj.png' 
                      alt='Telegram QR Code'
                      size='medium'
                      style={{ 
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        maxWidth: '300px',
                        cursor: 'zoom-in',
                      }}
                      onClick={() => setZoomedImage('/fj.png')}
                      onError={(e) => {
                        e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzAwIiBoZWlnaHQ9IjMwMCIgZmlsbD0iI2YwZjBmMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTgiIGZpbGw9IiM5OTkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5UZWxlZ3JhbSBRUiBDb2RlPC90ZXh0Pjwvc3ZnPg==';
                      }}
                    />
                    <p style={{ marginTop: '16px', color: '#666', fontSize: '14px' }}>
                      Please scan the QR code above to contact us on Telegram
                    </p>
                    <p style={{ marginTop: '8px', color: '#0088cc', fontSize: '16px', fontWeight: 'bold' }}>
                      Or visit: <a href='https://t.me/yourusername' target='_blank' rel='noopener noreferrer'>@yourusername</a>
                    </p>
                  </div>
                </Segment>
              </div>
            )}
          </Card.Content>
        </Card>

        {/* 温馨提示 */}
        <Segment style={{ 
          background: '#fff3cd', 
          border: '1px solid #ffc107',
          borderRadius: '8px',
          marginTop: '24px',
        }}>
          <Header as='h4' style={{ color: '#856404' }}>
            <Icon name='lightbulb outline' />
            {isChinese ? '💡 温馨提示' : '💡 Tips'}
          </Header>
          <div style={{ color: '#856404', lineHeight: '1.8' }}>
            {isChinese ? (
              <div>
                <p>• 客服工作时间：周一至周五 9:00-18:00</p>
                <p>• 添加客服时请备注您的平台账号</p>
                <p>• 充值后额度将即时到账</p>
                <p>• 如有紧急情况，请在消息中注明"紧急"</p>
              </div>
            ) : (
              <div>
                <p>• Customer Service Hours: Monday-Friday 9:00-18:00</p>
                <p>• Please mention your platform account when adding customer service</p>
                <p>• Quota will arrive instantly after recharge</p>
                <p>• For urgent matters, please mark "URGENT" in your message</p>
              </div>
            )}
          </div>
        </Segment>

        {/* 快速链接 */}
        <Segment style={{ borderRadius: '8px', marginTop: '24px' }}>
          <Header as='h4'>
            <Icon name='linkify' />
            {isChinese ? '快速链接' : 'Quick Links'}
          </Header>
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            <a href='/software-guide' style={{ color: '#667eea', textDecoration: 'none' }}>
              <Icon name='book' />
              {isChinese ? '新手教程' : 'Beginner Guide'}
            </a>
            <a href='/api-doc' style={{ color: '#667eea', textDecoration: 'none' }}>
              <Icon name='code' />
              {isChinese ? 'API 文档' : 'API Documentation'}
            </a>
            <a href='/topup' style={{ color: '#667eea', textDecoration: 'none' }}>
              <Icon name='cart' />
              {isChinese ? '充值页面' : 'Top Up'}
            </a>
          </div>
        </Segment>
      </Container>
      
      {/* 图片放大模态框 */}
      {zoomedImage && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            cursor: 'zoom-out',
          }}
          onClick={() => setZoomedImage(null)}
        >
          <img 
            src={zoomedImage} 
            alt="放大图片"
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              objectFit: 'contain',
              borderRadius: '8px',
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ContactUs;
